import { Component, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  MatDialogModule, MatDialogRef
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-folder-tree-dialog',
  standalone: true,
  imports: [TranslateModule, MatDialogModule, MatInputModule, FormsModule, MatButtonModule],
  templateUrl: './folder-tree-dialog.component.html',
  styleUrl: './folder-tree-dialog.component.scss'
})
export class FolderTreeDialogComponent {
  readonly dialogRef = inject(MatDialogRef<FolderTreeDialogComponent>);

  folderName: string = '';

  onNoClick(): void {
    this.dialogRef.close();
  }

  // Removed returnFolderName, use [mat-dialog-close]="folderName" in template
}
